import { tns } from 'tiny-slider/src/tiny-slider';

export default class HouseTypesSlider {
  constructor(element) {
    this.houseItems = document.querySelectorAll('.house-types__slider-item');
    this.slider = tns({
      container: element.querySelector('.js-slider'),
      gutter: 18,
      items: 7.3,
      loop: false,
      center: false,
      speed: 200,
      nav: false,
      responsive: {
        375: {
          items: 1.5
        },
        768: {
          items: 3.5
        },
        1024: {
          items: 7.3
        }
      },
      controlsContainer: element.querySelector('.js-slider-arrows')
    });
    this.markAsActive();
  }

  markAsActive() {
    for (let i = 0; i < this.houseItems.length; i++) {
      this.houseItems[i].addEventListener('click', (event) => {
        for (let j = 0; j < this.houseItems.length; j++) {
          if (this.houseItems[j].classList.contains('is--active')) {
            this.houseItems[j].classList.remove('is--active');
          } else {
            event.currentTarget.classList.add('is--active');
          }
        }
      });
    }
  }
}
